import { MenuOutlined } from '@ant-design/icons'
import { Button, Dropdown, MenuProps } from 'antd'
import { FC, useState } from 'react'
import { useRepeatOrder } from '../../../hooks/use-repeat-order'
import { DataSourceItem } from '../../../shipments-page'
import SetLogisticsCostModal from './set-logistics-cost-modal'

interface GroupOperationsProps {
    selectedRows: DataSourceItem[]
}

const GroupOperations: FC<GroupOperationsProps> = ({ selectedRows }) => {
    const { repeatOrder, isLoading } = useRepeatOrder()
    const [logisticsOpen, setLogisticsOpen] = useState(false)

    const items: MenuProps['items'] = [
        { key: 'repeat-order', label: 'Повторить заказ' },
        { key: 'logistics-cost', label: 'Указать стоимость логистики' },
    ]

    const onClick: MenuProps['onClick'] = ({ key }) => {
        if (key === 'repeat-order') repeatOrder(selectedRows)
        if (key === 'logistics-cost') setLogisticsOpen(true)
    }

    return (
        <>
            <Dropdown menu={{ items, onClick }} trigger={['click']}>
                <Button
                    title={'Групповые операции'}
                    size='small'
                    icon={<MenuOutlined />}
                    color='green'
                    variant={'solid'}
                    loading={isLoading}
                />
            </Dropdown>
            <SetLogisticsCostModal
                open={logisticsOpen}
                onClose={() => setLogisticsOpen(false)}
                selectedRows={selectedRows}
            />
        </>
    )
}

export default GroupOperations
